import { GetterTree } from 'vuex';
import { IRootState } from '@/store/types';
import { ICatalogueState } from '@/store/modules/catalogue/types';

export const getters: GetterTree<ICatalogueState, IRootState> = {
    GET_SORTED_CURRENCIES: (state) => {
        const rank = new Map(['RUB', 'EUR', 'USD', 'KZT'].map((c, i) => [c, i]));
        return [...state.currencies].sort((a, b) => {
            const ai = rank.get(a.code) ?? Infinity;
            const bi = rank.get(b.code) ?? Infinity;
            return ai !== bi ? ai - bi : a.code.localeCompare(b.code);
        });
    },
    GET_CURRENCIES: (state) => state.currencies,
    GET_COUNTRIES: (state) => state.countries,
    GET_CURRENT_CURRENCY_ICON: (state) => (item) => state.currencies.find((currency) => currency.code === item)?.symbol || '',
    GET_CURRENT_COUNTRY: (state) => (item) => state.countries.find((country) => country.code === item) || {},
};
